// extracted by mini-css-extract-plugin
export default {"main":"ProjectPage_main__4PIuM","body":"ProjectPage_body__mTwzr","project-card":"ProjectPage_project-card__N2rG5","left":"ProjectPage_left__qbE2e","right":"ProjectPage_right__V4bVL"};